/**
 * DetailModal Component
 *
 * Thin modal shell that wraps the unified action+shot detail content.
 * Handles SimpleModal rendering and environment detection.
 * All data fetching, filtering, and chart logic lives in ActionDetailContent.
 */

import { useCallback } from "react";
import { SimpleModal } from "../../components/Elements/SimpleModal/SimpleModal";
import { ActionDetailContent } from "../ActionDetailModal/ActionDetailModal";
import { useLeagueEnvironment } from "../../data/LeagueEnvironmentProvider";
import { ExplorerEnvironment } from "../../data/Cache";
import type { ShotQueryContext } from "../ShotDetailModal/types";
import "./DetailModal.scss";

interface DetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  queryContext: ShotQueryContext;
  teamId: string;
  teamAbbrev?: string;
  season?: string;
  seasonType?: string;
  modalTitle: string;
}

export default function DetailModal({
  isOpen,
  onClose,
  queryContext,
  teamId,
  teamAbbrev,
  season,
  seasonType,
  modalTitle,
}: DetailModalProps) {
  const environment = useLeagueEnvironment();
  const showCollegeLine = environment === ExplorerEnvironment.DRAFT;

  const handleClose = useCallback(
    (_event: object, _reason: string) => {
      onClose();
    },
    [onClose],
  );

  return (
    <SimpleModal
      isOpen={isOpen}
      handleClose={handleClose}
      title={modalTitle}
      maxWidth="xl"
      dialogClassName="detail-modal--dialog"
    >
      <ActionDetailContent
        queryContext={queryContext}
        teamId={teamId}
        teamAbbrev={teamAbbrev}
        season={season}
        seasonType={seasonType}
        showCollegeLine={showCollegeLine}
        showEPts={environment !== ExplorerEnvironment.DRAFT}
        modalTitle={modalTitle}
      />
    </SimpleModal>
  );
}
